import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TAP_LOCK_MS = 420;

export default function useSingleTapNavigate() {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const [navLocked, setNavLocked] = useState(false);

  useEffect(() => () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
  }, []);

  const goTo = useCallback((path, options) => {
    if (navLocked) return;

    setNavLocked(true);
    navigate(path, options);

    timeoutRef.current = window.setTimeout(() => {
      setNavLocked(false);
      timeoutRef.current = null;
    }, TAP_LOCK_MS);
  }, [navigate, navLocked]);

  return {
    goTo,
    navLocked,
  };
}
